module.exports = __webpack_public_path__ + "img/Dahlberg-10.dd5644c3.jpg";